module.exports = __webpack_public_path__ + "static/media/facebook.4b56d8ff.svg";